import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { SxProps } from '@mui/system';
import React from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';

interface ListItemLinkProps {
  icon?: React.ReactElement;
  primary: string;
  to: string;
  sx?: SxProps;
  showText?: boolean;
}

export default function ListItemLink({ icon, primary, to, sx, showText = true }: ListItemLinkProps) {

  const renderLink = React.useMemo(
    () =>
      React.forwardRef<HTMLAnchorElement, Omit<RouterLinkProps, 'to'>>(function Link(
        itemProps,
        ref,
      ) {
        return <RouterLink to={to} ref={ref} {...itemProps} role={undefined} />;
      }),
    [to],
  );

  return (
    // <Tooltip title={primary}>
    <ListItemButton sx={sx} component={renderLink}>
      {icon ? <ListItemIcon>{icon}</ListItemIcon> : null}
      {showText && (
        <ListItemText
          primary={primary}
          primaryTypographyProps={{
            sx: {
              fontSize: '16px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: 'flex',
              alignItems: 'center',
            },
          }}
        />
      )}
    </ListItemButton>
    // </Tooltip>
  );
}
